import { MESSAGES_CONSTS as MC } from '../consts'
import services from '@/services/ascentiaServiceIndex'

const state = {
  dAndCData: [],
  messages: [],
}

const comparator = function (a, b) {
  if (a.risk < b.risk) {
    return -1
  }
  if (a.risk > b.risk) {
    return 1
  }
  return 0
}

const getters = {
  allAlerts: state => {
    return state.messages
      .filter(message => message.risk > 30)
      .sort(comparator)
      .reverse()
  },
  allMessages: state => {
    return state.messages.sort(comparator).reverse()
  },
}

const actions = {
  // eslint-disable-next-line no-unused-vars
  async [MC.GET_MAINTENANCE_REC_PDF]({ commit }, maintRec) {
    try {
      // get the SAS key
      const pdfContainer = maintRec.btnArgs.pdfContainer
      const pdfName = maintRec.btnArgs.pdfName
      console.log(
        'getMaintRecPdfUrl: pdfContainer = ' +
          pdfContainer +
          ', pdfName = ' +
          pdfName,
      )
      const pdfSas = await services.blobTransfer.getData('pdf', {
        id: `${pdfContainer}-${pdfName}`,
        container: pdfContainer,
        name: pdfName,
      })
      console.log('getMaintRecPdfUrl: pdfSas = ' + pdfSas.data)

      // open the SAS in separate tab or window
      window.open(pdfSas.data, 'maintRecWindow')
      // use optional third param to force a window to open instead of tab
      // window.open(pdfSas.data, 'maintRecWindow', 'resizable,scrollbars,status')
    } catch (error) {
      console.log('getMaintRecPdfUrl: error ' + error)
    }
  },

  // FIXME: Not used any where verify and clean this.
  async [MC.GET_DANDC_DATA]({ commit, rootGetters }) {
    try {
      const response = await services.analytic.getData('dAndCData', null, false)
      const data = response.data.filter(item => {
        // Global Airline Filter
        if (rootGetters['globalFilter/showAllAirlines']) {
          return true
        } else {
          return (
            rootGetters['globalFilter/airlineIdsSelected'].indexOf(
              item.airlineId,
            ) > -1
          )
        }
      })
      commit(
        MC.UPDATE_DANDC_DATA,
        data.map(tail => {
          return {
            acid: tail.tail,
            operator: tail.operator,
            platform: tail.platform,
            risk: tail.risk,
            count: tail.count,
          }
        }),
      )
    } catch (error) {
      console.log(MC.UPDATE_DANDC_DATA + ': error ' + error)
    }
  },
}

const mutations = {
  [MC.UPDATE_DANDC_DATA]: (state, data) => (state.dAndCData = data),
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
